module.exports = __webpack_public_path__ + "assets/img/kiek-kainuoja-saules-elektrine.98303ff2.jpg";